<history-list title="Employee history" emptyLabel="No history found." [history]="history()" />
